// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kAvr","newExpiryDate":"styles_newExpiryDate__2ONM-","footer":"styles_footer__2OQLU"};